import React, { ReactNode } from 'react'
import { ComponentVariant, WidgetType } from '@otw/models'
import { SelectableWidget } from 'views/SuperAdmin/SuperAdminHome/components/builder/SelectableWidget'
import { WidgetSlot } from './DashboardWidgetSkeleton'

export interface DashboardWidgetProps {
  /** When set, enables dashboard-builder selection chrome. */
  widgetId?: WidgetType
  componentVariant?: ComponentVariant
  /**
   * Widget-specific loading. When provided, shows a skeleton then progressive-reveals
   * this widget alone when ready. Omit when the child owns its own query + reveal.
   */
  isLoading?: boolean
  loadingHeight?: number
  label?: string
  /** Override the Performance mark id when `widgetId` is omitted. */
  timingId?: string
  sx?: Record<string, unknown>
  children: ReactNode
}

/** Reusable dashboard widget shell. Pass only this widget's query loading flag. */
export const DashboardWidget: React.FC<DashboardWidgetProps> = ({
  widgetId,
  componentVariant,
  isLoading,
  loadingHeight = 180,
  label = 'Loading',
  timingId,
  sx,
  children,
}) => {
  if (widgetId) {
    return (
      <SelectableWidget
        widgetId={widgetId}
        componentVariant={componentVariant}
        isLoading={isLoading}
        loadingHeight={loadingHeight}
        label={label}
        sx={sx}
      >
        {children}
      </SelectableWidget>
    )
  }

  if (isLoading === undefined) {
    return <>{children}</>
  }

  return (
    <WidgetSlot
      loading={isLoading}
      minHeight={loadingHeight}
      label={label}
      timingId={timingId ?? 'overview-widget'}
    >
      {children}
    </WidgetSlot>
  )
}

export default DashboardWidget
